export default "/assets/images/icon-shield.svg?8e4caf31dc8515a28b512ea8ea94bece";